import { Box } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  show: boolean;
  label?: string;
  children: ReactNode;
};

export function ActivityDetailDiscrepancyDot({
  show,
  label = 'Nilai berbeda dari checkout',
  children,
}: Props) {
  return (
    <Box position="relative" w="full" minW={0}>
      {show ? (
        <Box
          position="absolute"
          top={0}
          right={0}
          w="6px"
          h="6px"
          borderRadius="full"
          bg="red.500"
          flexShrink={0}
          aria-label={label}
          data-testid="activity-detail-discrepancy-dot"
        />
      ) : null}
      {children}
    </Box>
  );
}
